export default {
  common: {
    email: 'Электронная почта',
    phone: 'Телефон',
    phoneNumber: 'Номер телефона',
    countrySelect: 'Выберите страну',
    countryUnmodifiedNote: 'Страну нельзя изменить после регистрации',
    next: 'Далее',
    back: 'Назад',
    attention: 'Внимание',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    modify: 'Изменить',
    ignore: 'Игнорировать',
    firstName: 'Имя',
    middleName: 'Отчество',
    lastName: 'Фамилия',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    birthday: 'День рождения',
    graphicCode: 'Графический код',
    emailCode: 'Код подтверждения электронной почты',
    smsCode: 'Код SMS',
    smsVerificationCode: 'Проверочный код по SMS',
    bind: 'Привязать',
    send: 'Отправить',
    resend: 'Повторно отправить',
    address: 'Адрес',
    done: 'Готово',
    systemMessage: 'Системное сообщение',
    setting: 'Настройка',
    submit: 'Отправить',
    language: 'Язык',
    edit: 'Изменить',
    delete: 'Удалить'
  },
  account: {
    account: 'Учетная запись',
    nickname: 'Псевдоним',
    id: 'ID',
    basicInfo: 'Базовый уровень',
    placeholder: 'Пожалуйста, введите',
    completed: 'Завершено',
    semiInfo: 'Полупроверено',
    fullyInfo: 'Полностью проверено',
    basicTab: 'Базовый',
    advancedTab: 'Расширенный',
    linkedAccount: 'Связанный счет вывода',
    accountSecurity: 'Учетная запись MetWallet и безопасность',
    logout: 'Выйти',
    semiToast: 'Пожалуйста, пройдите базовую проверку',
    fullyToast: 'Пожалуйста, пройдите базовую проверку \n и полупроверено',
    quickLoginTitle: 'Быстрый вход',
    cancelQuickLogin: 'Вы уверены, что хотите отключить быстрый вход?'
  },
  accountSecurity: {
    title: 'Учетная запись и безопасность',
    payPwd: 'Пароль для оплаты',
    loginPwd: 'Пароль для входа',
    changeEmail: 'Изменить адрес электронной почты',
    changePhone: 'Изменить номер телефона',
    changePayPwd: 'Изменить платежный пароль',
    changeLoginPwd: 'Изменить пароль для входа',
    bindEmail: 'Привязать адрес электронной почты',
    bindEmailNote: 'Пройдите проверку адреса электронной почты, чтобы привязать его',
    bindEmailPlaceholder: 'Введите адрес электронной почты, который вы хотите привязать',
    smsBindNote: 'Пройдите проверку по SMS, чтобы привязать его',
    bindPhone: 'Привязать номер телефона',
    smsAuthentication: 'Аутентификация по SMS',
    emailAuthentication: 'Аутентификация по электронной почте',
    phoneVerificationNote: 'Сначала пройдите проверку текущего номера телефона',
    bindPhonePlaceholder: 'Введите номер телефона, который вы хотите привязать',
    verificationWrongToast: 'Проверьте свой проверочный код',
    phoneNumberEmptyToast: 'Введите номер телефона',
    verificationCodeEmptyToast: 'Введите код',
    wrongCodeToast: 'Неправильный код',
    changeNote: 'Пройдите проверку, чтобы изменить ее.',
    newEmailVerification: 'Проверка нового адреса электронной почты',
    newEmailPlaceholder: 'Введите новый адрес электронной почты',
    change: 'Изменить',
    emailLowercaseToast: 'Адрес электронной почты должен быть указан строчными буквами.',
    newEmailEmptyToast: 'Пожалуйста, введите новый адрес электронной почты',
    changeSuccessToast: 'Изменение выполнено успешно',
    phonePlaceholder: 'Введите телефон',
    currentEmail: 'Текущий адрес электронной почты',
    passCurrentEmailVerificationFirst: 'Сначала пройдите проверку текущего адреса электронной почты',
    currentEmailVerification: 'Текущая проверка адреса электронной почты',
    smsVerification: 'Проверка SMS',
    currentPhoneNumber: 'Текущий номер телефона',
    currentPhoneVerification: 'Текущий номер телефона',
    currentEmailAddress: 'Текущий адрес электронной почты',
    phoneVerification: 'Проверка телефона',
    enterVerificationCode: 'Введите код подтверждения',
    newPhoneNumber: 'Новый номер телефона',
    newEmail: 'Новый электронный адрес'
  },
  withdrawAccount: {
    selectAccountType: 'Выбрать тип учетной записи',
    noBasicLevelVerificationDialog: 'Пожалуйста, пройдите базовую проверку перед привязкой способа вывода средств.',
    bindNote: 'Пожалуйста, введите правильные данные учетной записи, иначе вывод будет затронут.',
    bindBankAccount: 'Привязать банковский счет',
    bindMobileMoneyAccount: 'Привязать счет мобильных денег',
    fieldEmptyToast: '{0} требуется',
    fieldLengthToast: '{0} должен содержать не менее {1} символов',
    bindBankRepeatToast: 'Не привязывайте один и тот же банковский счет повторно!',
    accountName: 'Имя учетной записи',
    ifscCode: 'Код IFSC',
    accountEmptyToast: 'Требуется учетная запись',
    accountNameEmptyToast: 'Требуется имя учетной записи',
    phoneEmptyToast: 'Телефон требуется',
    emailEmptyToast: 'Требуется адрес электронной почты',
    ifscCodeEmptyToast: 'Требуется код IFSC',
    ifscCodeLengthToast: 'Код IFSC должен состоять из 11 цифр',
    bindIMPSRepeatToast: 'Не привязывайте один и тот же счет IMPS повторно!',
    bindNote2:
      'Введите правильный адрес TRC-20. Неправильный адрес приведет к потере платежа, за что мы не несем никакой ответственности.',
    usdtAddress: 'Адрес USDT (TRC-20):',
    minimumLimit: 'Минимальная сумма вывода за транзакцию: $10',
    usdtFee: 'Сбор: Подлежит фактическим сборам',
    registerGcash: 'Если у вас нет учетной записи Gcash, нажмите здесь, чтобы зарегистрироваться.',
    registerEpay: 'Если у вас нет учетной записи Epay, нажмите здесь, чтобы зарегистрироваться.',
    bindThirdPartyTitle: 'Привязать {0} учетную запись',
    wrongAccountToast: 'Неправильный счет',
    accountFormatToast: 'Неправильный формат учетной записи',
    bindThirdPartyFailedToast: 'Не удалось привязать {0}',
    queryFailedToast: 'Запрос не выполнен.',
    editFailedToast: 'Не удалось изменить.',
    add: 'Добавить',
    confirmEditDialog: 'Вы уверены, что хотите изменить учетную запись {0}?',
    payPwdRequireDialog: 'Пожалуйста, установите 6-значный платежный пароль перед добавлением учетной записи.',
    unbindFailedToast: 'Отвязка не удалась',
    cashOutSuccessNote: 'Предполагаемое время прибытия: в течение 7 рабочих дней',
    requestSubmitted: 'Заявка на вывод средств отправлена',
    amountLimitToast1: 'Сумма вывода должна быть ≥$40.00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'Сумма вывода должна быть ≥${0}.00',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'Советы: накопление суммы до ${0} перед выводом эффективно сэкономит ваши сборы за обработку.',
    amountNotEnoughToast: 'Сумма вывода недостаточна',
    exceedingLimitToast1: 'Сумма вывода сегодня достигла верхнего предела',
    exceedingLimitToast2:
      'Сумма вывода сегодня достигла верхнего предела. Нужно ли вам пройти расширенную сертификацию, чтобы поднять лимит?',
    restrictedCountriesPayPalAccountToast:
      'Не используйте учетную запись PayPal в странах с ограничениями, это приведет к блокировке вашего Arripay',
    withdrawMinimumToast: 'Минимальная сумма вывода за одну транзакцию: $40',
    bankNotAvailableToast: 'Этот банк больше не доступен, пожалуйста, свяжите другие банки.',
    usdtAccountInvalidToast: 'Этот счет USDT не может быть снят, пожалуйста, используйте новый счет для вывода.',
    noPayPwdToast: 'Пожалуйста, установите 6-значный платежный пароль перед выводом средств.',
    editBankAccount: 'Изменить банковский счет',
    accountPlaceholder: 'Введите свою учетную запись',
    trc20Placeholder: 'Введите адрес TRC-20',
    accountRepeatToast: 'Такой же, как и текущий.',
    unbindBankCardConfirmDialog: 'Вы уверены, что хотите отвязать банковскую карту {0}?',
    unbindMobileMoneyAccountConfirmDialog: 'Вы уверены, что хотите отвязать счет мобильных денег {0}?',
    unbindAccountConfirmDialog: 'Вы уверены, что хотите отвязать счет {0}?',
    availableBalance: 'Доступный баланс {0}',
    estimatedFee: 'Предполагаемая комиссия',
    submitFailToast: 'Отправить не удалось',
    disabledMethodToast: 'Этот канал временно недоступен',
    channelUnavailableTitle: 'Канал недоступен',
    channelUnavailableNote: 'Этот канал вывода временно недоступен. Попробуйте другой способ.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Банковский перевод недоступен',
    bankTransferUnavailableNote:
      'Банковский перевод сейчас недоступен для вашего счёта. Пожалуйста, используйте Epay для вывода.',
    channelMaintenanceTitle: 'Канал на обслуживании',
    channelMaintenanceNote: 'Этот канал вывода находится на обслуживании. Попробуйте другой способ.',
    bankInfoUpdateTitle: 'Обновите банковские данные',
    bankInfoUpdateNote: 'Из-за изменения политики банка обновите банковские реквизиты, чтобы продолжить.',
    bindEpay: 'Привязать Epay',
    useEpay: 'Использовать Epay',
    iMPSMaxLimitToast: 'Максимальная сумма вывода за одну транзакцию через этот канал составляет 260 долларов США.',
    linkedAccount: 'Счет добавлен',
    otherAccounts: 'Можно добавить другие счета',
    withdrawTo: 'Перевести на',
    withdrawAmount: 'Сумма перевода',
    withdrawable: 'Вывод средств',
    documentIdToast: 'ID Number может содержать только цифры',
    noAvailableMethodNote: 'Нет доступного способа вывода средств',
    recommended: 'Рекомендуем'
  },
  paymentCode: {
    changePayPwd: 'Изменить платежный пароль',
    setPayPwd: 'Установить платежный пароль',
    setPayPwdNote: 'Установите 6-значный платежный пароль',
    reenterPayPwdNote: 'Введите еще раз',
    verificationNote: 'Пройдите проверку, чтобы установить его.',
    emailVerification: 'Проверка электронной почты',
    inconsistentPasswordToast: 'Несоответствующий пароль',
    payPwdNote: 'Пожалуйста, введите платежный пароль',
    payPwdFormatToast: 'Платежный пароль — это 6-значное число',
    payPwdWrongToast: 'Неверный платежный пароль',
    payPwdVerificationFailToast: 'Проверка платежного пароля не пройдена!',
    successToast: 'Установить \n успешно'
  },
  authorize: {
    requirement:
      '{0} необходимо получить следующую информацию о вашем MetWallet{1}, чтобы предоставить вам соответствующую услугу. Псевдоним, аватар, пол и т. д.',
    authorize: 'Авторизация',
    switchAccount: 'Сменить учетную запись',
    goToMetWallet: 'Перейти в MetWallet',
    notMatchTips: 'Операция не удалась. Вы можете включить Быстрый вход только с привязанным аккаунтом MetWallet'
  },
  basicLevel: {
    namePlaceholder: 'Без символов, цифр',
    verification: 'Проверка',
    whatsAvailable: 'Что доступно',
    cashOut: 'Выплата',
    withdrawLimit: '$50 в день',
    basicLevelNote:
      'Пожалуйста, введите свои реальные личные данные. Неверная информация может привести к неудачной выплате.',
    fieldEmptyToast: 'Заполните все обязательные поля.',
    successToast: 'Сохранено \n успешно',
    failToast: 'Сохранить не удалось',
    confirmDialog:
      'Убедитесь, что вводите свои реальные личные данные. Неверная информация может привести к неудачной выплате.',
    birthdayFormatToast: 'Неверный формат поля «День рождения»',
    verificationCodeError: 'Ошибка кода подтверждения',
    verificationCodeEmpty: 'Пустой код подтверждения',
    noEmailCodeToast: 'Пожалуйста, получите код подтверждения по электронной почте',
    checkDialogTitle: 'Проверьте вашу информацию',
    checkDialogContent:
      'Для успешного вывода, пожалуйста, проверьте вашу информацию. Неверная информация может привести к неудачной выплате.',
    check: 'Проверить'
  },
  semiVerified: {
    uploadPhotoId: 'Загрузить фото ID',
    photoId: 'Фото ID',
    resubmit: 'Повторная отправка',
    limit: '5000 долларов в день',
    uploading: 'Загрузка...',
    notUploadProofToast: 'Загрузите подтверждение удостоверения личности'
  },
  fullyVerified: {
    frontOfId: 'Лицевая сторона ID',
    backOfId: 'Обратная сторона ID',
    uploadIdFront: 'Загрузить лицевую сторону',
    uploadIdBack: 'Загрузить обратную сторону',
    withdrawDailyHint: 'Заполните данные для вывода > {0} в день.',
    notUploadIdToast: 'Загрузите лицевую и обратную стороны удостоверения',
    proofTitle: 'ДОКУМЕНТ, ПОДТВЕРЖДАЮЩИЙ МЕСТОЖИТЕЛЬСТВО',
    acceptableProof: 'ПРИЕМЛЕМЫМ ДОКАЗАТЕЛЬСТВОМ МЕСТОЖИТЕЛЬСТВА ЯВЛЯЕТСЯ:',
    acceptableProof1: 'Выписка с банковского счета.',
    acceptableProof2: 'Счет за коммунальные услуги (электричество, вода, интернет и т. д.).',
    acceptableProof3: 'Документ, выданный правительством (налоговая декларация, свидетельство о резидентстве и т. д.).',
    unacceptableProof:
      'Мы не можем принять адрес, указанный в предоставленном вами документе, удостоверяющем личность, в качестве действительного доказательства проживания.',
    limit: '10 000 долларов США в день',
    notUploadToast: 'Загрузите документ, подтверждающий проживание',
    incorrectFormatToast: 'Загрузите изображение в формате jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'Пароль',
    lastLogin: 'Последний вход в систему',
    moreOptions: 'Дополнительные параметры',
    agreeCheckboxContent: 'Согласен с {0} и {1}',
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    notAgreeToast: 'Согласен с Пользовательским соглашением и Политикой конфиденциальности',
    forgotPassword: 'Забыли пароль',
    linkedMail: 'Связанная почта',
    verificationCode: 'Проверочный код',
    newPwd: 'Новый пароль',
    repeatPwd: 'Повторите пароль',
    confirmPwd: 'Подтвердите пароль',
    noLinkedEmailToast: 'Нет связанного адреса электронной почты с вашей учетной записью',
    unregisteredToast: 'Этот номер не зарегистрирован',
    pwdFormatToast: 'Формат пароля неверен',
    resetSuccessToast: 'Сброс \n успешно',
    pwdNotMatchToast: 'Пароли не совпадают дважды',
    emailFormatToast: 'Неправильный формат адреса электронной почты',
    phoneNumberFormatToast: 'Неправильный формат номера телефона',
    invalidAreaCodeToast: 'Неверный код региона',
    login: 'Войти',
    pwdLogin: 'Войти с помощью пароля',
    emailCodeLogin: 'Войти с помощью кода проверки адреса электронной почты',
    smsLogin: 'Войти с помощью SMS',
    verifyEmail: 'Подтвердить адрес электронной почты',
    verifyPhone: 'Подтвердить телефон',
    accountDangerDialog:
      'Ваша учетная запись была обнаружена как опасная. Пожалуйста, повторно подтвердите свою учетную запись, в противном случае ее нельзя будет использовать.',
    sendEmailCodeDialog: 'Мы отправили код проверки на ваш адрес электронной почты {0}. Введите код проверки.',
    sendSmsCodeDialog: 'Мы отправили код проверки на ваш телефон {0}. Введите код проверки.',
    graphicCodeEmptyToast: 'Введите графический код.',
    countryUnselectToast: 'Сначала выберите свою страну',
    unsupportedLoginTypeToast: 'Неподдерживаемый тип входа',
    pwdWrongLimitOverDialog: 'Неправильный пароль был введен 3 раза. Используйте код проверки SMS для входа.',
    loginFailedToast: 'Ошибка входа',
    signIn: 'Войти',
    pwdPlaceholder: 'Введите пароль',
    pwdNote: 'Введите 8-16 символов (буквы и цифры)',
    reenterPwdPlaceholder: 'Повторно введите пароль',
    reenterPwdNote: 'Повторно введите пароль',
    createAccount: 'Создать учетную запись',
    chooseCountryNote: 'Выберите страну',
    pwdInconsistentToast: 'Не совпадает с предыдущим введенным вами паролем',
    createSuccessToast: 'Создать \n успешно',
    registerFailToast: 'Ошибка регистрации',
    userNotExistToast: 'Пользователь не существует',
    phoneIncorrectToast: 'Проверьте свой телефон',
    userExistToast: 'Пользователь уже существует',
    countryCodeRepeatToast: 'Не вводите код страны повторно!',
    logoutDialog: 'Вы уверены, что хотите выйти?',
    pwdRequirement: 'Пароль должен содержать не менее 8–16 символов с буквами и цифрами',
    signup: 'Зарегистрироваться',
    registerSuccessToast: 'Зарегистрироваться \n успешно',
    oldPwdErrorToast: 'Проверьте старый пароль'
  },
  checkUserInfo: {
    title: 'Центр управления',
    emptyInfoNote: 'Здесь нет информации о текущем счете, проверьте счет MetWallet, который вам нужно подтвердить.',
    infoNote: 'Вот ваша информация о проверке.',
    lastSuccessWithdrawal: 'Последний успешный вывод средств',
    copyBtn: 'копия',
    successToast: 'Успешно скопировано!',
    failToast: 'Не удалось скопировать!'
  },
  country: {
    title: 'Выбрать регион',
    popular: 'Популярное'
  },
  documentDetails: {
    title: 'Сведения о документе',
    contract: 'Контракт',
    goToSign: 'Перейти к подписанию',
    download: 'Скачать',
    upload: 'Загрузить',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., только документы.',
    contentEmptyToast: 'Пожалуйста, введите содержимое',
    placeOfBirth: 'Место рождения',
    occupation: 'Род занятий',
    fileForm: '(Форма файла)',
    proofOfAddress: 'Подтверждение адреса на английском языке',
    residenceDoc: 'Документ о месте жительства',
    textForm: '(Текстовая форма)',
    contractAgent: 'Агент по контракту',
    contractPayslip: 'Расчетный лист по контракту',
    uncompletedToast: 'Пожалуйста, заполните его для отправки',
    successToast: 'Отправить успешно',
    undefinedFileTypeToast: 'Неопределенный тип загрузки файла',
    uploadFailToast: 'Загрузка не удалась'
  },
  filters: {
    amount: 'Сумма',
    filter: 'Фильтры',
    time: 'Время',
    reset: 'Сброс',
    timePickerTitle: 'Выбрать {0} Время',
    start: 'Начало',
    end: 'Конец',
    maximum: 'Максимум',
    minimum: 'Минимум'
  },
  home: {
    balance: 'Баланс',
    transactions: 'Транзакции',
    availableBalance: 'Доступный баланс',
    noWithdrawalMethodToast: 'Необходим как минимум один способ вывода средств.',
    linkAccount: 'Связать счет',
    all: 'Все',
    cashIn: 'Наличные',
    loading: 'загрузка...',
    noMore: 'Больше транзакций нет',
    reload: 'Загрузка не удалась, нажмите для перезагрузки',
    receivedFrom: 'Получено с',
    transferredTo: 'Переведено на',
    fee: 'Плата за перевод на',
    myEmail: 'Мой адрес электронной почты',
    myPhone: 'Мой телефон',
    invalidBasicLevelDialog:
      'Из-за включения символов, пробелов или цифр в поле имени вывод средств со счета невозможен. Пожалуйста, заполните основную информацию еще раз (убедитесь, что имя не содержит символов, пробелов или цифр, и если у вас нет фамилии или отчества, просто оставьте поле пустым.)',
    lackLastNameDialog: 'Ваша фамилия не указана, что помешает вашему выводу средств.',
    fillIn: 'Заполнить',
    viewDetails: 'Просмотреть сведения',
    docReviewingDialogTitle: 'Подождите, пока документ будет принят.',
    docReviewingDialogContent:
      'Вы отправили документ, но вы не сможете использовать MetWallet, пока ваш документ не будет принят.<br>Официальный персонал скоро его обработает, пожалуйста, подождите некоторое время.',
    docPassedDialog: 'Отправленный вами документ принят.<br>Теперь вы можете пользоваться MetWallet как обычно.',
    docUnqualifiedDialog:
      'Отправленный вами документ неквалифицирован.<br>Пожалуйста, отправьте квалифицированный документ.',
    goToSubmit: 'Перейти к отправке',
    uncompletedDialog: 'Вы должны заполнить его, чтобы использовать MetWallet как обычно',
    useMetWalletNormallyAfterPassed:
      'Вы сможете использовать MetWallet как обычно после того, как документ будет принят.',
    requireSemiVerifiedDialog:
      '{0}, по требованию банка, вы должны завершить полупроверенную часть в течение 48 часов для успешного вывода средств.',
    goToVerify: 'Перейти к проверке',
    emailInvalidDialog:
      '{0}, ваш адрес электронной почты совпадает с адресом другого человека. Для обеспечения конфиденциальности введите свой адрес электронной почты как можно скорее.',
    later: 'Позже',
    transferRequireSemiVerifiedDialog: 'Пожалуйста, пройдите полупроверенную проверку перед переносом.',
    modifyBtnText: 'Изменить мою информацию',
    unmodifiedTitle: 'Невозможно изменить',
    unmodifiedContent: 'У вас есть заказ на вывод в процессе. Информацию нельзя изменить сейчас.'
  },
  signing: {
    signature: 'Подпись',
    date: 'Дата',
    employeeName: 'Имя сотрудника',
    designation: 'Наименование',
    month: 'Месяц',
    year: 'Год',
    earnings: 'Доход',
    deductions: 'Вычеты',
    basic: 'Базовый и DA(USD)',
    totalAddition: 'Общее прибавление',
    totalDeduction: 'Общее вычет',
    salary: 'ЧИСТАЯ зарплата',
    refNo: 'Номер ссылки',
    paymentTransferDate: 'Дата перевода платежа',
    nameOfBank: 'Название банка',
    signatureOfEmployee: 'Подпись сотрудника',
    director: 'Директор',
    signNote: 'Пожалуйста, подпишите свое имя',
    preview: 'Предварительный просмотр',
    clear: 'Очистить',
    save: 'Сохранить',
    noSignatureToast: 'Вы не сможете сохранить без подписи.',
    fieldEmptyToast: 'Пожалуйста, заполните всю информацию.'
  },
  transactionDetail: {
    title: 'Сведения о транзакции',
    status: 'Статус',
    pending: 'Ожидание',
    completed: 'Завершено',
    success: 'SUCCESS',
    failed: 'Не удалось',
    cancelled: 'Отменено',
    onHold: 'Приостановлено',
    reason: 'Причина статуса',
    description: 'Описание',
    creationDate: 'Дата создания',
    lastStatusDate: 'Дата последнего статуса',
    requestedAmount: 'Запрошенная сумма',
    receiveAmount: 'Полученная сумма',
    transferAmount: 'Сумма перевода',
    amountToPay: 'Сумма к оплате',
    transferFee: 'Комиссия за перевод',
    processingFee: 'Комиссия за обработку',
    method: 'Способ',
    country: 'Страна',
    name: 'Название',
    bankPendingText: 'На заключительном банковском рассмотрении',
    pendingText: 'На рассмотрении {0}',
    chametSalary: 'зарплата Шаме',
    userSalary: 'Зарплата пользователя',
    comm: 'Комм.',
    gemgalaSalary: 'зарплата Гемгалы'
  },
  transfer: {
    title: 'На счет MetWallet',
    noPayPwdDialog: 'Перед переводом установите 6-значный пароль платежа.',
    records: 'Записи',
    cashInOut: 'Ввод наличных {0}, вывод наличных {1}',
    transfer: 'Перевод',
    fee: 'Комиссия',
    remark: 'Примечание',
    transferTo: 'Перевод на {0}',
    remarkPlaceholder: 'Добавьте примечание к переводу (менее 100 символов)',
    firstNameNote: 'Введите его/ее имя',
    sendingAmount: 'Сумма отправки',
    receivingAmount: 'Сумма получения',
    transferNow: 'Перевод сейчас',
    noBalanceToast: 'Сумма перевода больше суммы баланса.',
    amountTooLittleToast: 'Сумма перевода не может быть меньше $10.'
  },
  bankData: {
    beneficiaryName: 'Имя бенефициара',
    beneficiaryNamePlaceholder: 'Введите имя',
    beneficiaryLastname: 'Фамилия бенефициара',
    beneficiaryLastnamePlaceholder: 'Введите фамилию',
    bankCode: 'Код банка',
    bankCodePlaceholder: 'Выберите код банка',
    bankIFSCCode: 'Код IFSC банка',
    bankIFSCCodePlaceholder: 'Введите IFSC банка',
    bankAccount: 'Банковский счет',
    bankAccountPlaceholder: 'Введите банковский счет',
    email: 'Эл. почта',
    emailPlaceholder: 'Введите эл. почта',
    phoneNumber: 'Номер телефона',
    phoneNumberPlaceholder: 'Введите номер телефона',
    address: 'Адрес',
    addressPlaceholder: 'Введите адрес',
    city: 'Город',
    cityPlaceholder: 'Введите город',
    state: 'Штат',
    statePlaceholder: 'Введите штат',
    postCode: 'Почтовый индекс',
    postCodePlaceholder: 'Введите почтовый индекс',
    documentId: 'Идентификатор документа',
    documentIdPlaceholder: 'Введите идентификатор документа',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Тип документа',
    documentTypePlaceholder: 'Выберите тип документа',
    accountType: 'Тип счета',
    accountTypePlaceholder: 'Выберите тип счета',
    cpfcnpjPlaceholder: 'Введите CPFCNPJ',
    bankBranch: 'Отделение банка',
    bankBranchPlaceholder: 'Введите отделение банка',
    ribOfBankAccount: 'RIB банковского счета',
    bankName: 'Название банка',
    bankNamePlaceholder: 'Введите название банка',
    bicCode: 'Код BIC',
    bicCodePlaceholder: 'Введите код BIC',
    ibanPlaceholder: 'Введите IBAN',
    bankSwift: 'SWIFT банка',
    bankSwiftPlaceholder: 'Введите SWIFT банка',
    name: 'Название',
    documentCountry: 'Страна документа',
    documentCountryPlaceholder: 'Выберите страну документа',
    issueDate: 'Дата выдачи документа',
    issueDatePlaceholder: 'Выберите дату выдачи',
    expireDate: 'Дата истечения срока действия документа',
    expireDatePlaceholder: 'Выберите дату истечения срока действия',
    bankBranchName: 'Название отделения банка',
    bankBranchNamePlaceholder: 'Введите название отделения',
    branchPlaceholder: 'Введите Филиал',
    gender: 'Пол',
    genderPlaceholder: 'Выберите пол',
    birthday: 'День рождения',
    birthdayPlaceholder: 'Выберите день рождения',
    phone: 'Телефон',
    bankAddress: 'Адрес банка',
    bankAddressPlaceholder: 'Введите адрес банка',
    bankAccountName: 'Название банковского счета',
    bankAccountNamePlaceholder: 'Введите название банковского счета',
    province: 'Провинция',
    provincePlaceholder: 'Введите название провинции',
    postalCode: 'Почтовый индекс',
    postalCodePlaceholder: 'Введите почтовый индекс',
    savingsAccount: 'Сберегательный счет',
    abaRoutingNumber: 'Номер маршрутизации ABA',
    englandBankAccount: 'Счет в банке England',
    bankBranch2: 'bankBranch',
    bankBranch2Placeholder: 'Только если банк Santander',
    paternalName: 'Имя отца',
    paternalNamePlaceholder: 'Введите имя отца',
    passportIdNumber: 'Номер удостоверения личности паспорта',
    bankNamePlaceholder2: 'Выберите название банка',
    areaCode: 'Код города',
    phoneNumberNoAreaCode: 'Номер телефона (без кода города)',
    idType: 'Тип удостоверения',
    idNo: 'Номер удостоверения',
    idIssueDate: 'Дата выдачи удостоверения',
    idExpireDate: 'Дата истечения срока действия удостоверения',
    ibanStyleToast: "Пожалуйста, введите содержимое, начинающееся с 'SA' и длиной 24 символа."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'Вы можете переводить только продавцам бриллиантов',
    search: 'Поиск',
    history: 'Переведенные пользователи',
    confirm_content: 'Вы уверены, что переводите {0} на {1}',
    success_content: '{0} был переведен на {1}',
    purchase: 'Купить',
    purchase_success: 'Вы успешно приобрели {0}',
    insufficient_balance: 'Недостаточно средств',
    purchase_diamond: 'Купить бриллианты',
    transfer_limit_2: 'Сумма перевода должна быть от 10 до 30 000 долларов США',
    no_data: 'Нет данных',
    invalid_number: 'Введите допустимое число',
    under_limit: 'Сумма перевода должна быть не менее 10 долларов США',
    over_limit: 'Сумма перевода должна быть менее 30 000 долларов США'
  },
  redesign: {
    emailPlaceholder: 'Введите адрес электронной почты',
    retrievePwd: 'Восстановить пароль',
    resetPwd: 'Сбросить пароль',
    newPwdPlaceholder: 'Введите новый пароль',
    reenterNewPwdPlaceholder: 'Повторно введите новый пароль',
    reenterPayPwdPlaceholder: 'Пожалуйста, введите платежный пароль еще раз',
    sendToPhone: 'Код подтверждения был отправлен на ваш телефон',
    sendToWhatsapp: 'Код подтверждения был отправлен на ваш WhatsApp',
    sendToEmail: 'Код подтверждения был отправлен на ваш адрес электронной почты',
    invalidCode: 'Неверный код',
    userId: 'ID пользователя',
    other: 'Другое',
    transactionRecord: 'Запись транзакции',
    bankCardInfo: 'Счет банковской карты',
    withdrawInfo: 'Счет для вывода средств',
    toFillIn: 'Необходимо заполнить',
    walletInfo: 'Информация о счете кошелька',
    toComplete: 'Необходимо заполнить',
    verifyGuide: 'Заполните информацию о счете кошелька, чтобы получить больше квалификаций для вывода средств',
    verifyNote: 'Заполните следующую информацию, чтобы получить ежедневные квалификации для вывода средств {0}',
    verifyCompletedNote: 'Информация заполнена, чтобы получить ежедневные квалификации для вывода средств {0}',
    continueBtnText: 'Продолжайте заполнять',
    submitInfo: 'Отправить информацию',
    transferAmount: 'Сумма перевода',
    newEmailVerify: 'Новая проверка электронной почты',
    verifyCodePlaceholder: 'Введите код подтверждения',
    emailIncorrectToast: 'Пожалуйста, введите правильный адрес электронной почты',
    newPhone: 'Новый номер телефона',
    accountAdded: 'Информация об учетной записи добавлена',
    accountToAdd: 'Можно добавить другие счета',
    edit: 'Изменить',
    enterPayPwd: 'Введите платежный пароль',
    deleteBtnText: 'Удалить',
    transferTo: 'Перевести на',
    withdrawable: 'Вывод средств',
    goSet: 'Перейти установить',
    goModify: 'Перейти изменить'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/ru.js